<div class="container-fluid mb-5">
    <div class="row first">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 banner-col-1">
            <div class="row justify-content-end">
                <h6>Home Trial Cart 2.0</h6>
            </div>
            <div class="row mt-3 justify-content-end">
                <h3 class="fw-bold">It's An Experience!</h3>
            </div>
            <div class="row">
                <div class="col-auto pe-0">
                    <h3 class="fw-bold head-1">
                        Four Frames.
                    </h3>
                </div>
                <div class="col-auto pe-0">
                    <h3 class="fw-bold head-2">
                        Three Lenses.
                    </h3>
                </div>
                <div class="col-auto pe-0">
                    <h3 class="fw-bold head-3">
                        1 Laser
                    </h3>
                </div>
            </div>
            <div class="row whats-new-row">
                <div class="col-auto align-self-center">
                    <button class="btn fw-bold try-button" style="min-width: 90px;">Try Now</button>
                </div>
                <div class="col-auto align-self-center py-3">
                    <button class="btn play-button mx-1 d-inline">
                        <img src="../../assets/play.png" alt="">
                    </button>
                    <h6 class="no-bottom d-inline">Watch Whats New!</h6>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 banner-col-2">
            <img class="img-1" src="../../assets/Image 35.png" alt="">
            <img class="img-2" src="../../assets/Image 39.png" alt="">
            <img class="img-3" src="../../assets/Group 6248.png" alt="">
        </div>
    </div>
    <div class="row">
        <div class="col-12 lenses-col align-self-center">
            <h3 class="fw-bold">4 frames, 3 lenses, 7 days - direct to your home.</h3>
            <p class="para-color">We get it - sometimes you need to hold the glasses in your hand (or take a selfie
                wearing them) to know
                if they’re made for you
                or not. With our Free Home Trial, get 4 frames of your choice at your home, along with 3 cool lenses.
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-12 lenses-col align-self-center">
            <h3 class="fw-bold mb-5">Google & Fb Reviews</h3>
            <div class="row justify-content-center align-items-center my-3">
                <img class="rew-1" src="../../assets/5cb30b93b42e95ee807cc073b66ea1a2.png" alt="">
                <img class="rew-2 mx-3" src="../../assets/freepressjournal_import_2017_10_Tom-Cruise.png" alt="">
                <img class="rew-1" src="../../assets/808675.png" alt="">
            </div>
            <div class="text-center">
                <h5>Joshua Segar</h5>
            </div>
            <div class="text-center my-1">
                <img src="../../assets/stars.JPG" alt="">
            </div>
            <p class="para-color">Fantastic company! I discovered them while searching for home trial glassses on Google
                and I’m so glad I did! Excellent
                customer service, super fast and efficient! The website is very easy to use and very user friendly.
                While ordony glasses, I had
                some technical problems which were resolved within seconds by chat. The glasses arrived 2 days after
                ordering and came in
                a lovely box (looked a little bit like an iPhone box ;) ), together with an adjustment took and cleaning
                spray. The company
                certainly deserves the award that they recently received!
            </p>
        </div>
    </div>
    <div class="row third">
        <div class="row g1mob1 justify-content-center mb-5">
            <h3 class="">Lorem Ipsum Dolor Sit Amet, Consectetur.</h3>
        </div>
        <div class="row g1">
            <div class="col-6 pad-third-col-1">
                <h3 class="g1head">Lorem Ipsum Dolor Sit <br> Amet, Consectetur.</h3>
                <img class="g1image img-fluid" src="../../assets/G1.jpg" alt="">
            </div>
            <div class="col-6 pad-third-col-2">
                <img class="desk4image img-fluid" src="../../assets/Desk4.jpg" alt="">
                <p class="deskp">Lorem ipsum dolor sit amet, consectetur <br> adipiscing elit, sed do eiusmod tempor
                    <br>
                    incididunt ut labore et dolore magna aliqua. <br> Quis ipsum suspendisse ultrices…
                </p>
            </div>
        </div>
        <div class="row g1mob2 justify-content-center mt-5">
            <p class="">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices…</p>
        </div>
    </div>
    <div class="row fourth">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 fourth-col1">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn"><img src="../../assets/Group2965.png" alt=""></button>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <img class="img-fluid" src="../../assets/Glass1.jpg" alt="">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <button class="btn btn-dark color-picker"></button>
                    <button class="btn btn-light color-picker"></button>
                    <button class="btn btn-primary color-picker"></button>
                    <button class="btn btn-danger color-picker"></button>
                </div>
            </div>
            <div class="row justify-content-center align-items-center mt-3">
                <div class="col-auto text-center">
                    <p class="d-inline para-color fs-6">Tom Archer</p>
                    <p class="d-inline fw-bold fs-4 custom-margin">DARWEN 1</p>
                    <p class="d-inline para-color me-2 fs-6">£49.99</p>
                    <p class="d-inline fs-6 fw-bold">£39.99</p>
                </div>
            </div>
            <div class="row justify-content-center align-items-center mt-5">
                <div class="col-auto text-center">
                    <button class="d-inline btn btn-light try-button1">View</button>
                    <button class="d-inline btn btn-light try-button2">Try At Home</button>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 fourth-col2">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn"><img src="../../assets/Group2965.png" alt=""></button>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <img class="img-fluid" src="../../assets/Glass2.jpg" alt="">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <button class="btn btn-dark color-picker"></button>
                    <button class="btn btn-light color-picker"></button>
                    <button class="btn btn-primary color-picker"></button>
                    <button class="btn btn-danger color-picker"></button>
                </div>
            </div>
            <div class="row justify-content-center align-items-center mt-3">
                <div class="col-auto text-center">
                    <p class="d-inline para-color fs-6">Tom Archer</p>
                    <p class="d-inline fw-bold fs-4 custom-margin">DARWEN 1</p>
                    <p class="d-inline para-color me-2 fs-6">£49.99</p>
                    <p class="d-inline fs-6 fw-bold">£39.99</p>
                </div>
            </div>
            <div class="row justify-content-center align-items-center mt-5">
                <div class="col-auto text-center">
                    <button class="d-inline btn btn-light try-button1">View</button>
                    <button class="d-inline btn btn-light try-button2">Try At Home</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row px-5 fifth">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
            <h3 class="fw-bold">Awards.</h3>
            <h3 class="fw-bold">Followers. Rewards.</h3>
            <p class="para-color">Our work speaks for itself - Specscart has been awarded first prize in Venture Further
                2018 Business
                Category. We are constantly working to innovate new ways and technology to become UK’s leading Eye Care
                provider.</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 align-self-center">
            <img class="img-fluid" src="../../assets/specscart_awards_follower_rewards.png" alt="">
        </div>
    </div>
</div>